module.exports = __webpack_public_path__ + "img/alipay-plus.09c481dd.svg";